<template>
  <div id="criar-banner" class="cria-dicas">
    <h1 class="title text-uppercase font-weight-bold">
      {{ Fields.id ? 'Atualizar' : 'Criar' }} Banner
    </h1>
    <hr class="linha-amarela" />
    <div class="form-group" v-if="Fields.image !== null">
      <div class="box-img mb-4 shadow">
        <img
          :src="`${getImagesAddress}` + Fields.image"
          alt="Imagem do banner"
          class="obj my-img-fluid w-100 h-100"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="custom-file m-t-20">
        <input
          type="file"
          id="file"
          ref="file"
          class="custom-file-input"
          lang="pt"
          @change="uploadBanner()"
          accept="image/x-png, image/gif, image/jpeg"
        />
        <label
          class="custom-file-label"
          for="file"
          v-if="Fields.image === null && Fields.image === null"
        >
          Insira uma imagem com 1632px de largura e 552px de altura nesse campo!
        </label>
        <label class="custom-file-label" for="file" v-else>{{
          Fields.image
        }}</label>
      </div>
    </div>
    <div>
      <hr />
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="font-weight-bold">CIDADES</label>
          <div class="ml-2" v-if="Fields.citiesId.length === 0">
            <b-form-checkbox v-model="Fields.type" switch :value="0">
              Todas
            </b-form-checkbox>
          </div>
          <div class="ml-2" v-if="Fields.citiesId.length === 0">
            <b-form-checkbox v-model="Fields.type" switch :value="1">
              Públicas
            </b-form-checkbox>
          </div>
          <div class="ml-2" v-if="Fields.citiesId.length === 0">
            <b-form-checkbox v-model="Fields.type" switch :value="2">
              Privadas
            </b-form-checkbox>
          </div>
          <div
            class="m-0"
            v-if="Fields.citiesId.length > 0 && Fields.type === 3"
          >
            <div
              class="col-lg-4 col-md-6 col-sm-12 p-0 mb-2"
              v-for="(cidade, index) in Fields.citiesId"
              :key="index"
            >
              <v-select
                label="nome"
                :options="getCities"
                :reduce="(city) => city.id"
                v-model="Fields.citiesId[index]"
              ></v-select>
              <div class="btn-remove" @click="removeCity(index)">
                <i class="fas fa-times"></i>
              </div>
            </div>
          </div>
          <div
            class="m-t-20"
            v-if="
              Fields.type === null || Fields.type === false || Fields.type === 3
            "
          >
            <div>
              <label for="" class="font-weight-bold">Especificar cidade:</label>
            </div>
            <div
              class="btn bg-orange c-white c-white-hover ml-2"
              @click="
                () => {
                  addCities();
                  Fields.type = 3;
                }
              "
            >
              <i class="fas fa-plus mr-2"></i>
              <span>Adicionar</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="font-weight-bold">USUÁRIOS</label>
          <div class="row">
            <div class="col-md-6">
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="0">
                  Todos
                </b-form-checkbox>
              </div>
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="2">
                  Profissional
                </b-form-checkbox>
              </div>
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="3">
                  Lojista
                </b-form-checkbox>
              </div>
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="9">
                  Parceiro
                </b-form-checkbox>
              </div>
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="4">
                  Representante
                </b-form-checkbox>
              </div>
            </div>
            <div class="col-md-6">
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="1">
                  Cliente
                </b-form-checkbox>
              </div>
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="5">
                  Administrador
                </b-form-checkbox>
              </div>
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="6">
                  Editor
                </b-form-checkbox>
              </div>
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="8">
                  Convidado
                </b-form-checkbox>
              </div>
              <div class="ml-2">
                <b-form-checkbox v-model="Fields.user_type" switch :value="7">
                  Afiliado
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <hr />
    </div>
    <div class="form-group">
      <label for="url" class="font-weight-bold">URL</label>
      <input
        type="text"
        class="form-control input-form"
        id="cadastroUrl"
        v-model="Fields.url"
        placeholder="Link do banner"
      />
    </div>
    <div class="d-flex justify-content-end">
      <b-button @click="saveBanner()" class="mx-1" variant="success">
        <i class="fas fa-check mr-2 fs-16"></i>
        <span>
          {{ Fields.id ? 'Atualizar' : 'Criar' }}
        </span>
      </b-button>
      <b-button
        @click="backToBannerList()"
        class="mx-1 c-white"
        variant="warning"
      >
        <i class="fas fa-angle-left mr-2 fs-22"></i>
        <span>Voltar</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'CreateBanners',
  mixins: [makeToast],
  data: () => ({
    Fields: {
      id: 0,
      image: null,
      citiesId: [],
      type: null,
      url: null,
      user_type: null,
    },
  }),
  created() {
    this.$store.dispatch('admin/getCities');

    this.Fields.id = this.$route.params.bannerId || 0;

    if (this.Fields.id) {
      this.getBanner();
    }
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters('admin', ['getCities']),
  },
  methods: {
    ...mapActions('banner', ['getById', 'save']),
    getBanner() {
      this.$store.dispatch('startLoader');
      this.getById(this.Fields.id)
        .then((response) => {
          this.Fields = response.data.banner;
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    saveBanner() {
      this.$store.dispatch('startLoader');

      if (this.Fields.id) {
        Object.assign(this.Fields, { bannerId: this.Fields.id });
      }

      this.save(this.Fields)
        .then((response) => {
          this.makeToast('Sucesso!', response.data.data, 'success');
          setTimeout(() => {
            this.$router.push({ name: 'administrador-lista-banners' });
          }, 1000);
        })
        .catch((error) => {
          this.makeToast('Oops!', error.response.data, 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    addCities() {
      this.Fields.citiesId.push({});
    },
    removeCity(index) {
      this.Fields.citiesId.splice(index, 1);
    },
    backToBannerList() {
      this.$router.push({
        name: 'administrador-lista-banners',
      });
    },
    uploadBanner() {
      const formData = new FormData();
      // eslint-disable-next-line prefer-destructuring
      this.Fields.image = this.$refs.file.files[0];
      formData.append('file', this.Fields.image);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/sendUploadFiles', formData)
        .then((data) => {
          this.Fields.image = data.data.data;
          this.Fields.image = data.data.data;
          this.makeToast('Sucesso!', 'A imagem do banner foi inserida!', 'success');
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Oops!', 'Não foi possível inserir sua imagem, tente novamente em 5 minutos!', 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
  },
};
</script>

<style>
@import '../../../custom/css/cria-dicas.css';
</style>
